import * as React from "react"

const PhoneTalk = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    // style={{...props}}
  >
    <g clipPath="url(#a)" fill="#fff">
      <path d="M9.658 10.826a.423.423 0 0 1-.538.061c-.666-.472-1.426-1.025-2.005-1.604-.738-.738-1.549-1.73-2.02-2.355a.431.431 0 0 1 .035-.57c.715-.71 1.458-1.454 1.893-1.888L3.22.667 1.355 2.534c-.532.532-.758 1.26-.67 2.161.28 2.875 3.779 7.029 6.87 9.104 1.516 1.018 2.893 1.534 4.015 1.534.773 0 1.425-.244 1.92-.739l1.843-1.845-3.801-3.803-1.874 1.88Zm4.46 1.923-1.237 1.237c-.324.324-.774.484-1.321.484-.94 0-2.164-.47-3.525-1.385-2.869-1.926-6.242-5.88-6.494-8.473-.062-.634.08-1.128.421-1.47l1.26-1.26L5.806 4.47 4.524 5.75a1.3 1.3 0 0 0-.115 1.696c.487.648 1.33 1.677 2.098 2.446.626.627 1.42 1.205 2.116 1.698a1.274 1.274 0 0 0 1.644-.156l1.265-1.27 2.586 2.586ZM15.056 6.559A5.633 5.633 0 0 0 9.428.932v.938a4.694 4.694 0 0 1 4.689 4.689h.938Z" />
      <path d="M12.242 6.56h.938a3.756 3.756 0 0 0-3.751-3.752v.938a2.817 2.817 0 0 1 2.813 2.814Z" />
      <path d="M9.429 5.62c.517 0 .937.421.937.938h.938A1.878 1.878 0 0 0 9.43 4.683v.938Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default PhoneTalk